import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/CustomModal";
import Storage from "@/app/core/util/Storage";
import { useEffect } from "react";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { DateTranslate, OnlyDateTranslate } from "@/app/core/util/DateTranslater";
import { InvoiceController } from "@/app/core/base/controllers/InvoiceController";
import { PaymentHelper } from "@/app/core/util/helpers/PaymentHelper";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import { Panel, Tab, Tabs } from "@bumaga/tabs";
import DeliveryModal from "../delivery/DeliveryModal";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function InvoiceModal({ show, onHide, invoice }) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [national, setNational] = useState([]);
    const [international, setInternational] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (show && invoice) {
            loadInvoice()
        }
    }, [invoice, show])

    async function loadInvoice() {
        setLoading(true);
        InvoiceController.GetById(invoice.id, res => {
            let list = [];
            const myCountry = "BR";
            if (res.deliveryList != undefined && res.deliveryList.length > 0) {
                setNational(res.deliveryList.filter(x => x.origin.country == myCountry && x.destination.country == myCountry));
                setInternational(res.deliveryList.filter(x => x.origin.country != myCountry || x.destination.country != myCountry))
            }
            setData(res);
        })
        setLoading(false);
    }

    function save() {
    }

    function openDelivery(item) {
        setSelected(item.id);
        setShowModal(true)
    }

    return (
        <Modal
            title={Translate(Message.Invoice)}
            show={show}
            onHide={onHide}
            isLoading={loading}
            onSubmit={() => save()}>
            <div className="block-header">
                <div className="block-title">

                    <h2 className="content-heading font-w700">
                        {Translate(Message.Invoice)}: {data && OnlyDateTranslate(data.dueAt)}<br />
                    </h2>
                </div>
                <div className="block-tools"></div>
            </div>
            <div className="block-content">
                <div className="block-header mb-0 pb-0">
                    <div className="block-title">
                        <h2 className="content-heading font-w700">{Translate(Message.Delivery.Delivery)}s</h2>
                    </div>
                </div>
                <div className="block-content mt-0 pt-0">
                    <Tabs>

                        <Tab><button className="btn btn-dual"><i className="si si-map mr-2"></i> ({national.length}) {Translate(Message.NationalDelivery)}</button></Tab>
                        <Tab><button className="btn btn-dual"><i className="si si-globe-alt mr-2"></i> ({international.length}) {Translate(Message.InternationalDelivery)}</button></Tab>
                        <Panel>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>{Translate(Message.DeliveryCode)}</th>
                                        <th>{Translate(Message.Origin)}</th>
                                        <th>{Translate(Message.Destination)}</th>
                                        <th>Status</th>
                                        <th>{Translate(Message.Value)}</th>
                                        <th>{Translate(Message.RequestDate)}</th>
                                        {/* <th>{Translate(Message.Delivery.Delivery)}</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {national && national.map(item => (
                                        <tr>
                                            <td>{item.id}</td>
                                            <td>
                                                <span>
                                                    <b>{item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood}`}</b>
                                                    <br />
                                                    <small>{item && item.origin && `${item.origin.city} - ${item.origin.state}`}</small>
                                                </span>
                                            </td>
                                            <td>
                                                <span>
                                                    <b>{item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood}`}</b>
                                                    <br />
                                                    <small>{item && item.destination && `${item.destination.city} - ${item.destination.state}`}</small>
                                                </span>
                                            </td>
                                            <td>{DeliveryHelper().Status(item.status)}</td>
                                            <td>R${item && MoneyMask(item.totalPrice, 2)}</td>
                                            <td>{DateTranslate(item.createdAt)}</td>
                                            <td>
                                                <button className="btn btn-dual" onClick={() => openDelivery(item)}><i className="fa fa-eye" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Panel>
                        <Panel>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>{Translate(Message.DeliveryCode)}</th>
                                        <th>{Translate(Message.Origin)}</th>
                                        <th>{Translate(Message.Destination)}</th>
                                        <th>Status</th>
                                        <th>{Translate(Message.Value)}</th>
                                        <th>{Translate(Message.RequestDate)}</th>
                                        {/* <th>{Translate(Message.Delivery.Delivery)}</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {international && international.map(item => (
                                        <tr>
                                            <td>{item.id}</td>
                                            <td>
                                                <span>
                                                    <b>{item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood}`}</b>
                                                    <br />
                                                    <small>{item && item.origin && `${item.origin.city} - ${item.origin.state}`}</small>
                                                </span>
                                            </td>
                                            <td>
                                                <span>
                                                    <b>{item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood}`}</b>
                                                    <br />
                                                    <small>{item && item.destination && `${item.destination.city} - ${item.destination.state}`}</small>
                                                </span>
                                            </td>
                                            <td>{DeliveryHelper().Status(item.status)}</td>
                                            <td>R${item && MoneyMask(item.totalPrice, 2)}</td>
                                            <td>{DateTranslate(item.createdAt)}</td>
                                            <td>
                                                <button className="btn btn-dual" onClick={() => openDelivery(item)}><i className="fa fa-eye" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Panel>
                    </Tabs>
                </div>
            </div>
            <div className="block-content">
                <div className="block-header mb-0 pb-0">
                    <div className="block-title">
                        <h2 className="content-heading font-w700">{Translate(Message.Resume)}</h2>
                    </div>
                </div>
                <div className="block-content mt-0 pt-0">
                    <table className="table table-hover">
                        <tbody>
                            <tr>
                                <td style={{ width: "60%" }}>{Translate(Message.DueDate)}</td>
                                <th>{data && DateTranslate(data.dueAt)}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "60%" }}>{Translate(Message.BillingPeriod)}</td>
                                <th>{data && OnlyDateTranslate(data.start)} até {data && OnlyDateTranslate(data.end)}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "60%" }}>{Translate(Message.Delivery.Delivery)}</td>
                                <th>{data && data.deliveries}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "60%" }}>Status</td>
                                <th>{data && PaymentHelper.InvoiceTranslate(data.paymentStatus)}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "60%" }}>{Translate(Message.Value)}</td>
                                <th>R${data && MoneyMask(data.paymentAmount, 2)}</th>
                            </tr>
                            {/* <tr>
                                <td style={{ width: "60%" }}>{Translate(Message.Value)} total</td>
                                <th>R${data && MoneyMask(data.paymentAmount, 2)}</th>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </div>

            <DeliveryModal
                deliveryId={selected && selected}
                show={showModal}
                onHide={() => setShowModal(!showModal) | setSelected(null)} />
        </Modal>
    );
}
